import { updateKeyInStore } from 'App';
import { RentalActivityStateValues, updateKey } from '../slice';

export const uploadFields: IBaseField<keyof RentalActivityStateValues> | {}[] =
  [
    // fieldarray
    // {
    //   name: 'pleaseUploadACopyOfTheHudClosingStatement',
    //   label: 'Please upload a copy of the HUD closing statement.',
    //   type: 'upload',
    //   effect: updateKeyInStore(updateKey),
    //   tooltip:
    //     'Displayed in case the user selected Yes to the previous quesiton',
    //   comment: true,
    //   predicate: (v: string) => v === 'yes',
    //   dependentOn:
    //     'taxQuestionnaire.additionalQuestions.rentalActivity.values.howManyForms1099AreYouRequiredToFileForPaymentsYouMadeThisYear',
    // },
    // {
    //   name: 'pleaseUploadACopyOfPriorDepreciationSchedule',
    //   label: 'Please upload a copy of Prior Depreciation Schedule.',
    //   type: 'upload',
    //   effect: updateKeyInStore(updateKey),
    //   predicate: (v: string) => v === 'yes',
    //   dependentOn:
    //     'taxQuestionnaire.additionalQuestions.rentalActivity.values.doYouHaveAPriorDepreciationScheduleifFiledPreviousTaxReturn',
    // },
  ];
